import React from 'react';
import { Switch, Route, generatePath } from 'react-router-dom';
import omit from 'lodash/omit';

import { PROGRESS_CALCULATIONS_OMIT } from 'api/constants';

import * as routes from 'client/constants/routes';
import { useAppSelector, useTranslation, useResponsive } from 'client/hooks';
import { getProgress as getOnboardingProgress } from 'utils/onboarding/progress';
import { selectUserOnboarding } from 'client/redux/user/selectors';
import { selectLang } from 'client/redux/settings/selectors';

import { PageNavigation } from 'client/components/common';
import { Home } from './Home';
import { InvestorProfile } from './InvestorProfile';
import { Investments } from './Investments';
import { Library } from './Library';

import css from './InvestorPages.module.scss';

const InvestorPages = () => {
  const { translate: _t } = useTranslation('userProfile');
  const [isMobile] = useResponsive(['MOBILE']);
  const onboarding = useAppSelector(selectUserOnboarding);
  const lang = useAppSelector(selectLang);
  const onboardingProgress = getOnboardingProgress(onboarding);

  const navigation = React.useMemo(() => {
    const result = [
      { label: _t('investor.home'), path: generatePath(routes.USER_PROFILE_ROUTE, { lang }) },
      {
        label: _t('investor.investor'),
        path: generatePath(routes.USER_PROFILE_INVESTOR_ROUTE, { lang }),
        hasPendingAction: Object.values(omit(onboardingProgress, PROGRESS_CALCULATIONS_OMIT)).some((p) => p < 1),
      },
      { label: _t('investor.investments'), path: generatePath(routes.USER_PROFILE_INVESTMENTS_ROUTE, { lang }) },
    ];

    if (!isMobile) {
      result.push({ label: _t('investor.library'), path: generatePath(routes.USER_PROFILE_LIBRARY_ROUTE, { lang }) });
    }
    return result;
  }, [isMobile, onboardingProgress]);

  return (
    <>
      <PageNavigation navigation={navigation} />
      <div className={css.content}>
        <Switch>
          <Route exact path={routes.USER_PROFILE_ROUTE} component={Home} />
          <Route exact path={routes.USER_PROFILE_INVESTOR_ROUTE} component={InvestorProfile} />
          <Route exact path={routes.USER_PROFILE_INVESTMENTS_ROUTE} component={Investments} />
          {!isMobile && <Route exact path={routes.USER_PROFILE_LIBRARY_ROUTE} component={Library} />}
        </Switch>
      </div>
    </>
  );
};

export default InvestorPages;
